import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const digitalEcosystemEnablementStandardsPlugin = createPlugin({
  id: 'digital-ecosystem-enablement-standards',
  routes: {
    root: rootRouteRef,
  },
});

export const DigitalEcosystemEnablementStandardsPage = digitalEcosystemEnablementStandardsPlugin.provide(
  createRoutableExtension({
    name: 'DigitalEcosystemEnablementStandardsPage',
    component: () =>
      import('./components/DigitalEcosystemEnablementStandardsPage').then(m => m.DigitalEcosystemEnablementStandardsPage),
    mountPoint: rootRouteRef,
  }),
);
